import React from 'react'
import * as Sentry from '@sentry/react'

function FallbackComponent() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>Something went wrong.</h2>
      <p>Our team has been notified. Please refresh the page to try again.</p>
    </div>
  )
}

export default function ErrorBoundary({ children }) {
  return (
    <Sentry.ErrorBoundary fallback={<FallbackComponent />}>
      {children}
    </Sentry.ErrorBoundary>
  )
}
